import AnswerQuestion from "./AnswerQuestion";
import DescribeImage from "./DescribeImage";

import Pronunciation from "./Pronunciation";
import FixedConversation from "./ReadConversation";
import RepeatSentence from "./RepeatSentence";
import Roleplay from "./Roleplay";
import Video from "./Video";
import {
	SetNativeLanguage,
	SetEnglishLevel,
	SetGoals,
	SetInterests,
} from "../../../pages/Onboarding";

interface StepProps {
	stepInfo: any;
	onComplete?: () => void;
}

const Step: React.FC<StepProps> = ({ stepInfo }) => {
	const renderStep = () => {
		switch (stepInfo.type) {
			// Onboarding steps
			case "set_native_language":
				return <SetNativeLanguage />;
			case "set_english_level":
				return <SetEnglishLevel />;
			case "set_goals":
				return <SetGoals />;
			case "set_interests":
				return <SetInterests />;
			case "answer_question":
				return (
					<AnswerQuestion question={stepInfo.question} image={stepInfo.image} />
				);
			case "describe_image":
				return <DescribeImage image={stepInfo.image} />;
			case "pronunciation":
				return (
					<Pronunciation
						text={stepInfo.text}
						phonetic_breakdown="phonetic_breakdown"
						definition={stepInfo.definition}
						example={stepInfo.example}
					/>
				);
			case "repeat_sentence":
				return (
					<RepeatSentence
						expression={stepInfo.sentence}
						image={stepInfo.image}
					/>
				);
			case "video":
				return <Video video={stepInfo.video} />;
			case "conversation":
				return <FixedConversation dialogue={stepInfo.conversation} />;
			case "roleplay":
				return (
					<Roleplay
						scenario={stepInfo.scenario}
						llm_instructions={stepInfo.llm_instructions}
						voice_id={stepInfo.voice_id}
						image={stepInfo.scenario_image}
						profile_image={stepInfo.profile_image}
					/>
				);
			default:
				return null;
		}
	};

	return (
		<div className="flex flex-col h-full ">
			{/* Full height container */}
			<div className="flex-1 overflow-y-visible px-4 pt-4 pb-5">
				{/* Scrollable content with padding bottom for button */}
				{renderStep()}
			</div>
		</div>
	);
};

export default Step;
